import React, { useRef } from "react";

const BULLET = "•";

const nextPassword = (prevPassword, displayedValue, caret) => {
  const newLen = displayedValue.length;
  const prevLen = prevPassword.length;
  const safeCaret = caret ?? newLen;

  if (newLen === 0) return "";

  if (newLen > prevLen) {
    const addedCount = newLen - prevLen;
    const insertAt = Math.max(0, safeCaret - addedCount);
    const added = displayedValue.slice(insertAt, insertAt + addedCount).split(BULLET).join("");
    return prevPassword.slice(0, insertAt) + added + prevPassword.slice(insertAt);
  }

  if (newLen < prevLen) {
    const deleted = prevLen - newLen;
    return prevPassword.slice(0, safeCaret) + prevPassword.slice(safeCaret + deleted);
  }

  const replaceAt = Math.max(0, safeCaret - 1);
  const incoming = displayedValue[replaceAt];
  const nextChar = incoming === BULLET ? prevPassword[replaceAt] || "" : incoming;
  return prevPassword.slice(0, replaceAt) + nextChar + prevPassword.slice(replaceAt + 1);
};

const MaskedPasswordInput = ({
  className,
  placeholder = "••••••••",
  required = false,
  id,
  name = "password",
  value = "",
  onPasswordChange,
}) => {
  const inputRef = useRef(null);
  const password = value || "";

  return (
    <input
      ref={inputRef}
      id={id}
      className={className}
      type="text"
      inputMode="text"
      autoComplete="off"
      autoCorrect="off"
      autoCapitalize="off"
      spellCheck="false"
      required={required}
      placeholder={placeholder}
      value={BULLET.repeat(password.length)}
      name={`${name}-mask`}
      data-lpignore="true"
      data-form-type="other"
      onCopy={(e) => e.preventDefault()}
      onCut={(e) => e.preventDefault()}
      onContextMenu={(e) => e.preventDefault()}
      onChange={(e) => {
        const caret = e.target.selectionStart;
        const next = nextPassword(password, e.target.value, caret);
        onPasswordChange?.(next);
        requestAnimationFrame(() => {
          if (inputRef.current && typeof caret === "number") {
            inputRef.current.setSelectionRange(caret, caret);
          }
        });
      }}
    />
  );
};

export default MaskedPasswordInput;
